import { AppShellLayout } from "./AppShellLayout";
import { useLocation } from "react-router-dom";

const attributionEntrySegments = ["google", "bing", "meta"];
const footerSteps = ["quotes", "quote-detail", "results", "booking", "book-appointment"];

// Footer on the landing page and the results/booking steps; never on the form steps.
const LanderV2Layout = () => {
  const location = useLocation();
  const landerStepSegment = location.pathname.split("/").filter(Boolean)[3];
  const isEntryRoute = !landerStepSegment || attributionEntrySegments.includes(landerStepSegment);
  const shouldShowFooter = isEntryRoute || footerSteps.includes(landerStepSegment);

  return <AppShellLayout nav={null} showToolbar={false} showFooter={shouldShowFooter} />;
};

export { LanderV2Layout };
